export type TosItem = {
  name: string;
  value: number;
};

export function tos(): TosItem[] {
  return [
    { value: 0, name: 'normal' },
    { value: 1, name: 'min-monetary-cost' },
    { value: 2, name: 'max-reliability' },
    { value: 4, name: 'max-throughput' },
    { value: 8, name: 'min-delay' },
  ];
}
